import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./banner.module.scss";

export interface Banner {
  banner: string;
  _id: string;
}

interface Props {
  banners: Array<Banner>;
}

const TIMEOUT = 4 * 1000;

const BannerGallery: FC<Props> = ({ banners }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const history = useHistory();
  const touchStartX = useRef<number | null>(null);
  const validBanners = banners.filter((b) => b.banner);

  useEffect(() => {
    if (validBanners.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % validBanners.length);
    }, TIMEOUT);

    return () => clearInterval(interval);
  }, [validBanners.length]);

  const handlePaginationClick = (index: number) => {
    setCurrentIndex(index);
  };

  const handleBannerClick = (idoId: string) => {
    history.push(`/ido/${idoId}`);
  };

  const handleTouchStart = (event: React.TouchEvent) => {
    touchStartX.current = event.touches[0].clientX;
  };

  const handleTouchEnd = (event: React.TouchEvent) => {
    if (touchStartX.current === null) return;

    const touchEndX = event.changedTouches[0].clientX;
    const touchDiff = touchStartX.current - touchEndX;

    if (touchDiff > 50) {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % validBanners.length);
    } else if (touchDiff < -50) {
      setCurrentIndex(
        (prevIndex) =>
          (prevIndex - 1 + validBanners.length) % validBanners.length
      );
    }

    touchStartX.current = null;
  };

  if (validBanners.length === 0) {
    return null;
  }

  const currentBanner = validBanners[currentIndex];

  if (!currentBanner) {
    return null;
  }

  const paginationDots = Array.from(
    { length: validBanners.length },
    (_, i) => i
  );

  return (
    <div
      className={styles.bannerContainer}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className={styles.bannerImage}
        onClick={() => handleBannerClick(currentBanner._id)}
      >
        <img src={currentBanner.banner} alt={`Banner ${currentIndex + 1}`} />
      </div>

      <div className={styles.paginationContainer}>
        {paginationDots.map((dotIndex) => (
          <span
            key={dotIndex}
            className={
              dotIndex === currentIndex
                ? styles.activeDot
                : styles.paginationDot
            }
            onClick={() => handlePaginationClick(dotIndex)}
          />
        ))}
      </div>
    </div>
  );
};

export default BannerGallery;
